// extracted by mini-css-extract-plugin
export default {"root":"Ffw0_AMsphRGddEFbzZb","close":"yIkfxQ540t5KW8mo3dPU"};